import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { initSentry } from "./lib/sentry";
import "./index.css";

// Initialize Sentry before creating React root
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
